(() => {
  const root = document.querySelector('[data-bbs-root]');
  if (!root || root.dataset.bbsInitialized) return;
  root.dataset.bbsInitialized = '1';

  const els = {
    grid: root.querySelector('[data-bbs-grid]'), count: root.querySelector('[data-bbs-count]'), town: root.querySelector('[data-bbs-town]'),
    street: root.querySelector('[data-bbs-street]'), streets: root.querySelector('[data-bbs-streets]'), empty: root.querySelector('[data-bbs-empty]'),
    inventoryEmpty: root.querySelector('[data-bbs-inventory-empty]'), modal: root.querySelector('[data-bbs-modal]'), modalContent: root.querySelector('[data-bbs-modal-content]'),
    checkin: root.querySelector('[data-bbs-checkin]'), checkout: root.querySelector('[data-bbs-checkout]'), guests: root.querySelector('[data-bbs-guests]'),
    context: root.querySelector('[data-bbs-context]'), clearStreet: root.querySelector('[data-bbs-clear-street]'), layout: root.querySelector('[data-bbs-layout]')
  };

  const url = root.dataset.supabaseUrl;
  const key = root.dataset.supabaseKey;
  if (!url || !key || !window.supabase) {
    els.grid.innerHTML = '<div class="bbs-setup"><strong>Beach by Street needs its Supabase connection.</strong><span>Set the Hub project URL and publishable key in the section settings.</span></div>';
    return;
  }

  const sb = window.supabase.createClient(url, key);
  let all = [], visible = [], towns = [], map, markerLayer;
  const defaultCenter = [35.77, -75.70];

  async function boot() {
    initMap();
    setDateMinimums();
    const [{ data: townData, error: townErr }, { data: props, error: propErr }] = await Promise.all([
      sb.from('bbs_towns').select('id,name,slug,latitude,longitude,sort_order').eq('active', true).order('sort_order'),
      sb.from('bbs_properties').select('*, bbs_rental_companies(name,logo_url,website_url)').eq('active', true).order('featured', { ascending: false }).limit(2500)
    ]);
    if (townErr || propErr) return showError((townErr || propErr).message);
    towns = townData || [];
    all = props || [];
    towns.forEach(t => els.town.insertAdjacentHTML('beforeend', `<option value="${t.id}">${escapeHtml(t.name)}</option>`));
    els.inventoryEmpty.hidden = all.length > 0;
    await applySearch();
  }

  function initMap() {
    if (!window.L) return;
    map = L.map(root.querySelector('[data-bbs-map]'), { scrollWheelZoom: false }).setView(defaultCenter, 9);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
    markerLayer = L.layerGroup().addTo(map);
  }

  function setDateMinimums() {
    const today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
    const iso = today.toISOString().slice(0,10); els.checkin.min = iso; els.checkout.min = iso;
  }

  async function applySearch() {
    const townId = els.town.value;
    const street = els.street.value.trim().toLowerCase();
    const guests = Math.max(1, Number(els.guests.value || 1));
    const flags = [...root.querySelectorAll('[data-bbs-filter]:checked')].map(el => el.dataset.bbsFilter);
    let data = all.filter(p => (!townId || p.town_id === townId) && (!street || (p.street_name || '').toLowerCase().includes(street)) && (!p.sleeps || p.sleeps >= guests) && flags.every(k => !!p[k]));

    const checkIn = els.checkin.value, checkOut = els.checkout.value;
    if (checkIn && checkOut && checkOut > checkIn && data.length) {
      const { data: slots, error } = await sb.from('bbs_property_availability').select('property_id,price').eq('available', true).lte('start_date', checkIn).gte('end_date', checkOut);
      if (!error) {
        const prices = new Map((slots || []).map(s => [s.property_id, s.price]));
        data = data.filter(p => prices.has(p.id)).map(p => ({ ...p, search_price: prices.get(p.id) }));
      }
    }

    visible = data;
    render();
  }

  function render() {
    els.count.textContent = visible.length.toLocaleString();
    const townName = towns.find(t => t.id === els.town.value)?.name;
    els.context.textContent = els.street.value ? `on ${els.street.value}` : townName ? `in ${townName}` : 'across the Outer Banks';
    els.clearStreet.hidden = !els.street.value;
    els.empty.hidden = visible.length !== 0 || all.length === 0;
    els.inventoryEmpty.hidden = all.length !== 0;
    els.grid.innerHTML = visible.map(card).join('');
    renderStreets(); renderMap(); bindCards();
  }

  function renderStreets() {
    let basis = all.filter(p => !els.town.value || p.town_id === els.town.value);
    const groups = new Map();
    basis.forEach(p => { const name = (p.street_name || '').trim(); if (name) groups.set(name, (groups.get(name) || 0) + 1); });
    const rows = [...groups.entries()].sort((a,b) => a[0].localeCompare(b[0]));
    if (!rows.length) {
      els.streets.innerHTML = `<div class="bbs-empty">${all.length ? 'No streets match this town yet.' : 'Street names will populate automatically with imported rentals.'}</div>`;
      return;
    }
    els.streets.innerHTML = rows.map(([name,n]) => `<button type="button" data-street-name="${escapeAttr(name)}" class="${els.street.value === name ? 'is-active' : ''}"><span>${escapeHtml(name)}</span><b>${n}</b></button>`).join('');
    els.streets.querySelectorAll('[data-street-name]').forEach(btn => btn.onclick = () => { els.street.value = btn.dataset.streetName; applySearch(); });
  }

  function renderMap() {
    if (!map || !markerLayer) return;
    markerLayer.clearLayers();
    const bounds = [];
    visible.forEach(p => {
      const lat = Number(p.latitude), lng = Number(p.longitude); if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      const label = `<strong>${escapeHtml(p.address_line1)}</strong><br>${p.bedrooms ?? '—'} bd · Sleeps ${p.sleeps ?? '—'}<br><button class="bbs-popup-button" data-map-property="${p.id}">View house</button>`;
      const marker = L.marker([lat,lng]).bindPopup(label); marker.addTo(markerLayer); bounds.push([lat,lng]);
    });
    if (bounds.length > 1) map.fitBounds(bounds, { padding: [30,30], maxZoom: 14 });
    else if (bounds.length === 1) map.setView(bounds[0], 15);
    else {
      const t = towns.find(x => x.id === els.town.value);
      if (t?.latitude && t?.longitude) map.setView([Number(t.latitude), Number(t.longitude)], 12); else map.setView(defaultCenter, 9);
    }
    setTimeout(() => map.invalidateSize(), 50);
  }

  function bindCards() {
    els.grid.querySelectorAll('[data-property-id]').forEach(el => el.addEventListener('click', e => {
      if (e.target.closest('a,button')) return; openProperty(el.dataset.propertyId);
    }));
    els.grid.querySelectorAll('[data-book]').forEach(a => a.addEventListener('click', () => trackReferral(a.dataset.propertyId, a.dataset.companyId, 'property-card')));
  }

  function card(p) {
    const company = p.bbs_rental_companies?.name || 'Rental company';
    const amount = p.search_price ?? p.price_from;
    const price = amount ? `$${Number(amount).toLocaleString()}${p.search_price ? ' for selected stay' : '/' + (p.price_unit || 'week')}` : 'See live rate';
    const image = p.hero_image_url ? `style="background-image:url('${escapeAttr(p.hero_image_url)}')"` : '';
    return `<article class="bbs-card" data-property-id="${p.id}">
      <div class="bbs-photo" ${image}><span>${escapeHtml(p.street_number || '')}</span>${p.oceanfront ? '<em>Oceanfront</em>' : ''}</div>
      <div class="bbs-card-body"><div class="bbs-address">${escapeHtml(p.address_line1)}</div><div class="bbs-meta">${p.bedrooms ?? '—'} bd · ${p.bathrooms ?? '—'} ba · Sleeps ${p.sleeps ?? '—'}</div>
      <div class="bbs-tags">${p.pool ? '<span>Pool</span>' : ''}${p.hot_tub ? '<span>Hot tub</span>' : ''}${p.pet_friendly ? '<span>Pet friendly</span>' : ''}${p.elevator ? '<span>Elevator</span>' : ''}</div>
      <div class="bbs-price">${price}</div><div class="bbs-manager">Managed by ${escapeHtml(company)}</div>
      <div class="bbs-card-actions"><button type="button" data-open-house="${p.id}">See house</button><a class="bbs-book" data-book data-property-id="${p.id}" data-company-id="${p.rental_company_id}" href="${escapeAttr(p.booking_url)}" target="_blank" rel="noopener noreferrer">Book direct →</a></div></div></article>`;
  }

  async function openProperty(id) {
    const p = all.find(x => x.id === id); if (!p) return;
    const { data: photos } = await sb.from('bbs_property_photos').select('image_url,alt_text,sort_order').eq('property_id', id).eq('licensed_or_authorized', true).order('sort_order');
    const sameStreet = visible.filter(x => x.street_name === p.street_name).sort((a,b) => String(a.street_number || '').localeCompare(String(b.street_number || ''), undefined, { numeric:true }));
    const idx = sameStreet.findIndex(x => x.id === id), prev = sameStreet[idx-1], next = sameStreet[idx+1];
    els.modalContent.innerHTML = `<div class="bbs-modal-hero" style="background-image:url('${escapeAttr(p.hero_image_url || '')}')"></div>
      <div class="bbs-modal-body"><div class="bbs-eyebrow">${escapeHtml(p.street_name)}</div><h2>${escapeHtml(p.address_line1)}</h2><p>${escapeHtml(p.description || '')}</p>
      <div class="bbs-modal-stats"><span><b>${p.bedrooms ?? '—'}</b> bedrooms</span><span><b>${p.bathrooms ?? '—'}</b> baths</span><span><b>${p.sleeps ?? '—'}</b> sleeps</span><span><b>${p.ocean_distance_yards ?? '—'}</b> yds to ocean</span></div>
      ${(photos || []).length ? `<div class="bbs-photo-strip">${photos.map(ph => `<img loading="lazy" src="${escapeAttr(ph.image_url)}" alt="${escapeAttr(ph.alt_text || p.address_line1)}">`).join('')}</div>` : ''}
      <div class="bbs-street-nav">${prev ? `<button type="button" data-prev-house="${prev.id}">← ${escapeHtml(prev.street_number || 'Previous house')}</button>` : '<span></span>'}${next ? `<button type="button" data-next-house="${next.id}">${escapeHtml(next.street_number || 'Next house')} →</button>` : '<span></span>'}</div>
      <a class="bbs-book bbs-book-large" data-modal-book href="${escapeAttr(p.booking_url)}" target="_blank" rel="noopener noreferrer">Book directly with ${escapeHtml(p.bbs_rental_companies?.name || 'rental company')} →</a></div>`;
    els.modalContent.querySelector('[data-modal-book]')?.addEventListener('click', () => trackReferral(p.id, p.rental_company_id, 'property-modal'));
    els.modalContent.querySelector('[data-prev-house]')?.addEventListener('click', e => openProperty(e.currentTarget.dataset.prevHouse));
    els.modalContent.querySelector('[data-next-house]')?.addEventListener('click', e => openProperty(e.currentTarget.dataset.nextHouse));
    if (!els.modal.open) els.modal.showModal();
  }

  async function trackReferral(propertyId, companyId, source) {
    const sessionId = sessionStorage.bbsSession || (sessionStorage.bbsSession = crypto.randomUUID());
    const { data: { session } } = await sb.auth.getSession();
    await sb.from('bbs_referral_clicks').insert({ property_id: propertyId, rental_company_id: companyId || null, user_id: session?.user?.id || null, session_id: sessionId, source, search_town_id: els.town.value || null, search_street: els.street.value || null, check_in: els.checkin.value || null, check_out: els.checkout.value || null });
  }

  function showError(message) { els.grid.innerHTML = `<div class="bbs-setup"><strong>Database connection issue</strong><span>${escapeHtml(message)}</span></div>`; }

  root.querySelector('[data-bbs-search]').onclick = applySearch;
  els.town.onchange = () => { els.street.value = ''; applySearch(); };
  els.checkin.onchange = () => { if (els.checkin.value) els.checkout.min = els.checkin.value; };
  els.street.addEventListener('input', () => { clearTimeout(els.street._t); els.street._t = setTimeout(applySearch, 180); });
  els.guests.addEventListener('change', applySearch);
  root.querySelectorAll('[data-bbs-filter]').forEach(x => x.onchange = applySearch);
  els.clearStreet.onclick = () => { els.street.value = ''; applySearch(); };
  root.querySelectorAll('[data-view]').forEach(btn => btn.onclick = () => {
    root.querySelectorAll('[data-view]').forEach(x => x.classList.toggle('is-active', x === btn));
    els.layout.dataset.view = btn.dataset.view;
    if (map) setTimeout(() => map.invalidateSize(), 80);
  });
  els.modal.querySelector('[data-bbs-close]').onclick = () => els.modal.close();
  els.modal.addEventListener('click', e => { if (e.target === els.modal) els.modal.close(); });
  document.addEventListener('click', e => { const b = e.target.closest('[data-map-property],[data-open-house]'); if (b) openProperty(b.dataset.mapProperty || b.dataset.openHouse); });

  function escapeHtml(v=''){return String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}
  function escapeAttr(v=''){return escapeHtml(v).replace(/`/g,'&#96;');}
  boot();
})();
